import React from 'react';
import NumberFormat from 'react-number-format';

interface PercentCellProps {
  value: number;
}

export const PercentCell = ({ value }: PercentCellProps) => {
  return <NumberFormat value={(value * 100).toFixed(2)} displayType='text' thousandSeparator={true} suffix={'%'} />;
};
